import { JsonConverter } from 'json2typescript';
import { HvlEnumConverter } from '@hvlng/framework-bff/util';

export enum EnumPersonalDataApprovalStatus {
    DRAFT = 'DRAFT',
    WAITING_APPROVAL = 'WAITING_APPROVAL',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    TRANSFERRED = 'TRANSFERRED',
    SEND_TO_COMMITTEE = 'SEND_TO_COMMITTEE',
    WAITING_REVISE = 'WAITING_REVISE',
    CANCELED = 'CANCELED',
}

export const EnumPersonalDataApprovalStatusKey = 'hrBpmn.enumPersonalDataApprovalStatus';

@JsonConverter
export class EnumPersonalDataApprovalStatusConverter extends HvlEnumConverter<EnumPersonalDataApprovalStatus> {
    constructor() {
        super(EnumPersonalDataApprovalStatus, 'EnumPersonalDataApprovalStatus');
    }
}
